<template>
  <div>
    <div v-if="items.length" class="alerts">
      <div class="alert-wrapper fixed">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="alert"
          :class="{ 'alert-danger': item.error, 'alert-success': !item.error }"
        >
          <div
            class="alert__inner d-flex align-items-center justify-content-between"
          >
            <span class="alert__text">{{ $t(item.text) }}</span>
            <div>
              <a class="ml-3 font-weight-bolder" @click="close(index)">{{
                $t("ok")
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import _ from "lodash";
import axios from "axios";
export default {
  props: {
    notifications: Array
  },
  data() {
    return {
      items: []
    };
  },
  computed: {},
  watch: {
    notifications: function() {
      if (this.notifications.length) {
        this.translateNotifications();
        this.timeoutClose();
      }
    }
  },
  mounted() {},
  methods: {
    timeoutClose() {
      setTimeout(() => {
        this.close(0);
      }, 5000);
    },
    close(index) {
      if (!index) {
        this.items = [];
      } else {
        this.items.splice(index, 1);
      }

      if (!this.items.length) {
        this.$store.commit("modals/clearGlobalNotification");
        if (this.$route.params.notifications) {
          this.$route.params.notifications = [];
        }
      }
    },
    translateNotifications() {
      console.log("this.notifications");
      console.log(this.notifications);

      let notificationItems = [];
      // convert ultidimensional array in notification
      if (this.notifications[0].length > 0) {
        this.notifications[0].forEach(item => {
          if (item.text) notificationItems.push(item);
        });
      } else {
        if (this.notifications.length > 0) {
          this.notifications.forEach(item => {
            if (item.text) notificationItems.push(item);
          });
        }
      }

      if (notificationItems.length > 0) {
        // translate all notifications
        notificationItems.forEach(item => {
          if (item.text && !item.params) {
            this.items.push({ text: item.text, error: false });
          } else {
            axios
              .post(process.env.VUE_APP_APICMS + "/translate", {
                item: {
                  message: item.text,
                  attribute: item.params
                }
              })
              .then(result => {
                result.data.forEach(result => {
                  let translate = this.$t(result);
                  this.items.push({ text: translate, error: false });
                });
              })
              .catch(() => {});
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.alert {
  display: block;
}
</style>
